import { CalendarDays } from "lucide-react";
import { inr, fmtDate } from "../lib/api";

const dayName = (s) => new Date(`${s}T00:00:00`).toLocaleDateString("en-IN", { weekday: "short" });

export const DailyTable = ({ days, onSelect }) => (
  <div className="bg-surface border border-line overflow-x-auto" data-testid="daily-table">
    <div className="px-4 py-3 border-b border-line flex items-center gap-2">
      <CalendarDays className="h-4 w-4 text-brand" />
      <h2 className="font-display text-base md:text-lg font-semibold">Date-wise Summary</h2>
      <span className="text-xs text-muted-c ml-auto">Tap a date to see its entries</span>
    </div>
    <table className="w-full text-sm min-w-[560px]">
      <thead className="bg-head border-b border-line">
        <tr className="font-mono text-[11px] uppercase tracking-wider text-muted-c text-left">
          <th className="px-4 py-3">Date</th><th className="px-4 py-3">Entries</th>
          <th className="px-4 py-3 text-right">Deposit</th><th className="px-4 py-3 text-right">Withdraw</th>
          <th className="px-4 py-3 text-right">Net</th>
        </tr>
      </thead>
      <tbody>
        {days.length === 0 && <tr><td colSpan={5} className="px-4 py-8 text-center text-muted-c" data-testid="daily-empty">No entries in this period</td></tr>}
        {days.map((d) => (
          <tr key={d.date} onClick={() => onSelect(d.date)} className="border-b border-line/60 row-hover cursor-pointer" title="View entries" data-testid={`daily-row-${d.date}`}>
            <td className="px-4 py-3 font-mono whitespace-nowrap">{fmtDate(d.date)} <span className="text-muted-c text-xs ml-1">{dayName(d.date)}</span></td>
            <td className="px-4 py-3 font-mono">{d.entry_count}</td>
            <td className="px-4 py-3 text-right font-mono text-pos">{inr(d.deposit)}</td>
            <td className="px-4 py-3 text-right font-mono text-neg">{inr(d.withdraw)}</td>
            <td className={`px-4 py-3 text-right font-mono font-semibold ${d.net < 0 ? "text-neg" : "text-net"}`}>{inr(d.net)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
